import { useState, useEffect } from 'react';

const BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;
const API_TOKEN = process.env.REACT_APP_AIRTABLE_API_TOKEN;

function Home() {
  const [photoUrl, setPhotoUrl] = useState(null);
  const [bioContent, setBioContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.airtable.com/v0/${BASE_ID}/Site%20Data`, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const bioRecord = data.records?.find(
          (record) => record.fields.Name === 'Bio'
        );
        const photoRecord = data.records?.find(
          (record) => record.fields.Name === 'About Photo'
        );

        if (bioRecord?.fields?.Content) {
          setBioContent(bioRecord.fields.Content);
        }

        const photo = photoRecord?.fields?.Attachments?.[0];
        if (photo) {
          setPhotoUrl(photo.url);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching home data:', err);
        setLoading(false);
      });
  }, []);

  if (loading) return null;

  return (
    <section className="pt-20 md:pt-32 pb-16 px-4 md:px-0 md:flex">
      <div className="hidden md:block md:w-1/4" />
      <div className="w-full md:w-3/4 flex flex-col-reverse md:flex-row gap-8 md:pr-8">
        {bioContent && (
          <div
            className="w-full md:w-2/3 text-base md:text-lg text-left leading-relaxed"
            dangerouslySetInnerHTML={{ __html: bioContent }}
          />
        )}
        {photoUrl && (
          <div className="w-full md:w-1/3">
            <img
              src={photoUrl}
              alt="About"
              className="w-full h-auto"
            />
          </div>
        )}
      </div>
    </section>
  );
}

export default Home;